/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 匿名用户ID取值范围
 */
export const ANONYMOUS_ID_RANGE = {
    MIN: 0,
    MAX: 4294967294,
};

/**
 * 匿名用户ID默认值
 */
export const ANONYMOUS_ID_DEFAULT = 65534;

/**
 * 源端口校验限制枚举
 */
export enum SecureE {
    SECURE = '0',
    INSECURE = '1'
}
